import { motion } from "framer-motion";

const TONES = {
  emerald: "#059669",
  green: "#10B981",
  amber: "#F59E0B",
  red: "#EF4444",
};

const ARC = Math.PI * 84;

export const ScoreGauge = ({ score, label = "PisoScore", tone = "emerald", light = false, testid = "result-pisoscore-score" }) => (
  <div className="relative mx-auto w-full max-w-[240px]" data-testid={testid}>
    <svg viewBox="0 0 200 116" className="w-full">
      <path
        d="M 16 108 A 84 84 0 0 1 184 108"
        fill="none"
        stroke={light ? "rgba(255,255,255,0.12)" : "#E2E8F0"}
        strokeWidth="14"
        strokeLinecap="round"
      />
      <motion.path
        d="M 16 108 A 84 84 0 0 1 184 108"
        fill="none"
        stroke={TONES[tone]}
        strokeWidth="14"
        strokeLinecap="round"
        strokeDasharray={ARC}
        initial={false}
        animate={{ strokeDashoffset: ARC * (1 - Math.min(Math.max(score, 0), 100) / 100) }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      />
    </svg>
    <div className="absolute inset-x-0 bottom-0 flex flex-col items-center">
      <div className="flex items-baseline gap-1">
        <motion.span
          key={score}
          initial={{ scale: 0.92, opacity: 0.5 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.35 }}
          className={`font-mono text-5xl font-bold tabular-nums ${light ? "text-white" : "text-slate-900"}`}
        >
          {score}
        </motion.span>
        <span className={`font-mono text-sm ${light ? "text-slate-400" : "text-slate-400"}`}>/100</span>
      </div>
      <span className={`mt-1 text-xs font-semibold uppercase tracking-widest ${light ? "text-slate-400" : "text-slate-500"}`}>
        {label}
      </span>
    </div>
  </div>
);
